export default __webpack_public_path__ + "static/media/art.5f5516d9.svg";